import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'dailyReport';

const dailyReportService = {
  getRow: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  updateRow: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      formData: true,
      data,
    });
  },

  deleteRow: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};
export default dailyReportService;
